module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Grolley-Ponthaux_COA-1476d2adea7a2e56dc65cd837418646a.svg";